import { useState, FC } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { useTranslation } from 'react-i18next';
import { GridSelectorModalWindow } from '../../../../components/modalWindows/GridSelectorModalWindow';
import { IEntitySimpleDTO } from '../../../../libs/coreapi-dto/@types/common';
import { DisposalReasonGismtSelectPluginSettings } from '../pluginSettings/disposalReasonGismtSelectPluginSettings';
import { DisposalReasonGismtGrid } from '../grid/disposalReasonGismtGrid';

export const DisposalReasonGismtSelectorModalSelectorModal: FC<IGridSelectorModalProps> = (props) => {
    const [entity, setEntity] = useState<IEntitySimpleDTO>(props.selectedEntity ?? ({} as IEntitySimpleDTO));
    const [focusTaken, setFocusTaken] = useState<boolean>(false);

    const gridId = uuidv4();
    const plugin = DisposalReasonGismtSelectPluginSettings;
    const { t } = useTranslation();

    return (
        <GridSelectorModalWindow
            gridDisplayName={plugin?.name ?? ''}
            entityToPressEnter={entity}
            ok={{ onClick: () => props.ok?.(entity) }}
            cancel={{ onClick: () => props.cancel?.() }}
            focusTaken={focusTaken}
        >

            {
                plugin ? (
                    <DisposalReasonGismtGrid
                        gridId={gridId}
                        plugin={plugin}
                        onSelect={(row) => {
                            const newEntity = row ? { idGlobal: row.idGlobal, displayName: row.displayName } : null;
                            setEntity(newEntity ?? ({} as IEntitySimpleDTO));
                        }}
                        onDoubleClick={(row) => {
                            const newEntity = row ? { idGlobal: row.idGlobal, displayName: row.displayName } : null;
                            setEntity(newEntity ?? ({} as IEntitySimpleDTO));
                            props.ok?.(newEntity);
                        }}
                        onFocusChanged={(taken: boolean) => {
                            setFocusTaken(taken);
                        }}
                    />
                ) : (
                    <p> {t('general.directoryNotConfigured')}</p>
                )
            }
        </GridSelectorModalWindow>
    );
};
